import { redirect, createFileRoute } from '@tanstack/react-router';

/**
 * The month folder is a view of the calendar rather than a screen of its own
 * (WG-26 always described it as one). The path is kept because it is in
 * bookmarks and in anything shared onward, and it opens the same folder.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/calendar',
      params,
      search: { view: 'month' },
    });
  },
});
